import React from "react";
import PropTypes from "prop-types";

import "./Login.css";
import Link from "components/shared/Link/Link";
import LoginImageRow from "./LoginImageRow";
import LoginDescriptionRow from "./LoginDescriptionRow";
import LoginPoweredByImageRow from "./LoginPoweredByImageRow";
import LoginPage from "components/Login/LoginPage";

import urlServices from "services/urlServices";
import deviceServices from "services/deviceServices";

import localize from "lang/localize";

import {
  ENABLE_REGISTER_PAGES,
  PRIVACY_PAGE_LINK,
  ENABLE_LOGIN_HOME,
  ENABLE_LOGIN_TOPBAR
} from "config";

const propTypes = {
  email: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  handleEmailChange: PropTypes.func.isRequired,
  handlePasswordChange: PropTypes.func.isRequired,
  handleUpdateMarketingConsent: PropTypes.func.isRequired,
  handleUpdatePrivacyAgreed: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handlePrivacySubmit: PropTypes.func.isRequired,
  showPrivacyAgreement: PropTypes.bool,
  marketingConsent: PropTypes.bool,
  privacyAgreed: PropTypes.bool.isRequired,
  projectId: PropTypes.number,
  topbarlessBackButtonRoute: PropTypes.string,
  /* Custom: Project Description */
  projectDescription: PropTypes.string,
  language: PropTypes.string,
  /* Guest Login Dialog */
  guestEnabled: PropTypes.bool.isRequired,
  showGuestLoginDialog: PropTypes.bool.isRequired,
  handleOpenGuestLoginDialog: PropTypes.func.isRequired,
  handleCloseGuestLoginDialog: PropTypes.func.isRequired,
  /* Show Recaptcha */
  userRecaptchaActivate: PropTypes.bool,
  /* OAuth */
  responseFacebook: PropTypes.func.isRequired,
  responseFacebookError: PropTypes.func.isRequired,
  responseGoogle: PropTypes.func.isRequired,
  responseGoogleError: PropTypes.func.isRequired,
  /* Loading indicators */
  isSubmitLoading: PropTypes.bool,
  setSubmitLoading: PropTypes.func
};

class GourmetGrammarLoginPage extends LoginPage {
  /* Custom: Pure button, removed grids */
  renderTopbarlessBackButton() {
    if (ENABLE_LOGIN_HOME && !ENABLE_LOGIN_TOPBAR) {
      return (
        <Link
          className="topbarless-back-button"
          to={this.props.topbarlessBackButtonRoute}
        >
          <i className="fas fa-arrow-left" />
        </Link>
      );
    } else {
      return null;
    }
  }

  render() {
    if (
      /* checking type is important: showPrivacyAgreement is initialised as null */
      typeof this.props.showPrivacyAgreement === "boolean" &&
      this.props.showPrivacyAgreement === true
    ) {
      return (
        <div className="login-register-container container verticalpadding flex-from-md">
          {this.renderTopbarlessBackButton()}
          <div className="innerblock flex-from-md align-items-center">
            <div
              className={
                "pure-u-1-1 pure-u-md-11-24 horizontalpadding-5" +
                (ENABLE_LOGIN_HOME && !ENABLE_LOGIN_TOPBAR
                  ? " topmargin-40"
                  : "")
              }
            >
              <div className="pure-g">
                <div className="hide-from-md">
                  <LoginImageRow />
                </div>
                <h2 className="welcome-to-header textcenter fullwidth">
                  {localize(
                    "gourmetgrammar_login_view_welcome_text",
                    this.props.language
                  )}
                </h2>
                <h2 className="gourmet-grammar-header textcenter fullwidth">
                  {localize(
                    "gourmetgrammar_gourmet_grammar_text",
                    this.props.language
                  )}
                </h2>
                <LoginDescriptionRow
                  projectDescription={this.props.projectDescription}
                />
              </div>
              <div>
                <div className="pure-u-1-1">
                  <h5 className="textcenter gourmet-grammar-privacy-policy-title">
                    {localize(
                      "login_view_privacy_policy_updated_title",
                      this.props.language
                    )}
                  </h5>
                  <p className="textcenter gourmet-grammar-privacy-policy-text">
                    {localize(
                      "login_agree_to_new_terms_text",
                      this.props.language
                    )}
                  </p>
                  <div className="bottommargin-30">
                    <p className="smalltext">
                      <input
                        type="checkbox"
                        onChange={this.props.handleUpdatePrivacyAgreed}
                        checked={this.props.privacyAgreed}
                      />{" "}
                      {localize(
                        "register_agree_to_gametize_text",
                        this.props.language
                      )}
                      <a
                        className="link default"
                        href={PRIVACY_PAGE_LINK}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {localize(
                          "register_privacy_policy_text",
                          this.props.language
                        )}
                      </a>
                      .
                    </p>
                    <p className="smalltext">
                      <input
                        type="checkbox"
                        onChange={this.props.handleUpdateMarketingConsent}
                        checked={this.props.marketingConsent}
                      />{" "}
                      {localize(
                        "register_marketing_communications_text",
                        this.props.language
                      )}
                    </p>
                  </div>
                  <div className="pure-g bottommargin">
                    <div className="pure-u-11-24 pure-u-sm-14-24 pure-u-lg-2-3" />
                    <div className="pure-u-13-24 pure-u-sm-10-24 pure-u-lg-1-3">
                      <button
                        className={
                          "button fullwidth " +
                          (this.props.privacyAgreed ? "cta" : "inactive")
                        }
                        onClick={this.props.handlePrivacySubmit}
                        disabled={!this.props.privacyAgreed}
                      >
                        {localize("button_quest_continue", this.props.language)}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="pure-u-1-1 pure-u-md-1-12 hide-below-md" />
            <div className="pure-u-1-1 pure-u-md-11-24 horizontalpadding-5 hide-below-md">
              <div className="hide-below-md">
                <LoginImageRow />
                <LoginPoweredByImageRow />
              </div>
            </div>
          </div>
          <div className="hide-from-md topmargin-10">
            <LoginPoweredByImageRow />
          </div>
        </div>
      );
    } else {
      return (
        <div className="login-register-container container verticalpadding flex-from-md">
          {this.renderTopbarlessBackButton()}
          <div className="innerblock flex-from-md align-items-center">
            <div
              className={
                "pure-u-1-1 pure-u-md-11-24 horizontalpadding-5" +
                (ENABLE_LOGIN_HOME && !ENABLE_LOGIN_TOPBAR
                  ? " topmargin-40"
                  : "")
              }
            >
              <div className="pure-g">
                <div className="hide-from-md">
                  <LoginImageRow />
                </div>
                <h2 className="welcome-to-header textcenter fullwidth">
                  {localize(
                    "gourmetgrammar_login_view_welcome_text",
                    this.props.language
                  )}
                </h2>
                <h2 className="gourmet-grammar-header textcenter fullwidth">
                  {localize(
                    "gourmetgrammar_gourmet_grammar_text",
                    this.props.language
                  )}
                </h2>
                <LoginDescriptionRow
                  projectDescription={this.props.projectDescription}
                />
              </div>
              <div>
                <div className="pure-u-1-1">
                  <form
                    className="pure-form"
                    onSubmit={this.handlePreSubmit.bind(this)}
                  >
                    {this.renderLoginFields()}
                    {this.renderGuestLoginSection()}
                    {/* Add hidesso=true to query string in order to hide sso login, e.g. /login?hidesso=true */}
                    {urlServices.getUrlParamValueByKey("hidesso") !== "true" &&
                      !deviceServices.isWebView() &&
                      this.renderSSOLoginSection()}
                    {ENABLE_REGISTER_PAGES && this.renderRegisterSection()}
                  </form>
                </div>
              </div>
            </div>
            <div className="pure-u-1-1 pure-u-md-1-12 hide-below-md" />
            <div className="pure-u-1-1 pure-u-md-11-24 horizontalpadding-5 hide-below-md">
              <div className="hide-below-md">
                <LoginImageRow />
                <LoginPoweredByImageRow />
              </div>
            </div>
          </div>
          <div className="hide-from-md topmargin-10">
            <LoginPoweredByImageRow />
          </div>
        </div>
      );
    }
  }
}

GourmetGrammarLoginPage.propTypes = propTypes;

export default GourmetGrammarLoginPage;
